import "./App.css";
import Landing from "./pages/landing";
import PropertyList from "./pages/propertyList";
import PropertyAdd from "./pages/propertyAdd";
import ProductList from "./pages/productList";
import EnquiryList from "./pages/enquiryList";
import Login from "./pages/login";
import NewLandingPage from "./pages/newladingpage";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import PopupPage from "./pages/popupPage";

import { useEffect, useState } from "react";
import FullPageLoader from "./pages/loader";

function App() {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    const userDataFromLocalStorage = JSON.parse(
      localStorage.getItem("userData")
    );
    setLoading(false); // Set loading to false after retrieving user data

    setUserData(userDataFromLocalStorage);
  }, []);

  if (loading) {
    return <FullPageLoader />; // Render loading indicator while fetching user data
  }

  return (
    <Router>
      <Routes>
        {/* <Route path="/" element={<Landing />} /> */}
        <Route path="/" element={<NewLandingPage />} />

        <Route path="/login" element={<Login />} />
        <Route path="/congratulation/:coupon" element={<PopupPage />} />

        {userData && userData.token ? (
          <>
            <Route path="/property" element={<PropertyList />} />
            <Route path="/property/add/:id" element={<PropertyAdd />} />
            <Route path="/property/add" element={<PropertyAdd />} />
            <Route path="/products" element={<ProductList />} />
            <Route path="/enquiry" element={<EnquiryList />} />
          </>
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;
